import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import _ from 'lodash'

import * as Constants from './../../../helpers/constants'
import showToastNotification from './../../widgets/toastify'
import { ApiHelper } from './../../../helpers/apihelper'

const initialState = {
  emailAddress: '',
  errors: {},
  responseData: [],
  hasSearched: false
}

const GetGatewayEmailUsers = ({ client }) => {
  const [state, setState] = useState(initialState)

  const handleEmailChange = (e) => {
    const emailValue = e.target.value
    setState(prevState => ({ ...prevState, emailAddress: emailValue }))
  }

  const validateEmail = (email) => {
    const emailRegex = Constants.REGEX.EMAIL_SYNTAX
    const isValidEmail = emailRegex.test(email)

    if (!isValidEmail) {
      setState(prevState => ({
        ...prevState, errors: {
          emailAddress: 'Enter a valid email address'
        }
      }))

      setTimeout(() => {
        setState(prevState => ({
          ...prevState,
          errors: {
            emailAddress: null
          }
        }))
      }, 5000)
    }

    return isValidEmail
  }

  const handleFindUsers = () => {
    const isValidEmail = validateEmail(state.emailAddress)

    if (!isValidEmail) {
      return false
    }

    const requestQueryParams = {
      email: state.emailAddress,
      client_secret: Constants.CLIENT_SECRET
    }

    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'FIND_USERS_BY_GATEWAY_EMAIL').API_QUERY)

    ApiHelper(client, 'FIND_USERS_BY_GATEWAY_EMAIL').API(client, queryParams)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: response.message || 'Failed',
            isSuccess: false,
          })
        } else {
          setState((prevState) => ({
            ...prevState,
            responseData: response.data || [],
            hasSearched: true
          }))
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const showUsers = () => {
    if (state.hasSearched && !state.responseData.length) {
      return <div className="text-muted">No users found</div>
    }

    return (
      <div
        className="d-grid gap-2 grid-pattern-background"
      >
        {state.responseData.map((item, index) => (
          <a
            key={index}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-light text-start"
          >
            {item.email}
          </a>
        ))}
      </div>
    )
  }

  const handleReset = () => {
    setState((prevState) => ({
      ...prevState,
      emailAddress: '',
      responseData: [],
      hasSearched: false
    }))
  }

  return (
    <div className='mis-wrapper'>
      <h5 className='heading-title'>Payment Gateway Email</h5>
      <p className='heading-subtext'>
        Find users with payment gateway email
      </p>
      <Form>
        <div className='row'>
          <Form.Group className='mt-4'>
            <Form.Label
              htmlFor='payment-gateway-users__input'
              className='mb-1'
            >
              Email Address:
            </Form.Label>
            <div className='col-md-12'>
              <div className='d-flex'>
                <Form.Control
                  type="email"
                  id="payment-gateway-users__input"
                  placeholder="Enter Email Address"
                  value={state.emailAddress}
                  onChange={handleEmailChange}
                  isInvalid={!!state.errors.emailAddress}
                />
                <Button
                  variant='outline-secondary'
                  className='filter-reset-btn ms-2'
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </div>
              <Form.Control.Feedback type="invalid">
                {state.errors.emailAddress}
              </Form.Control.Feedback>
            </div>
          </Form.Group>
        </div>
      </Form>
      {showUsers()}
      <div className='payment-gateway-users__button'>
        <Button
          variant="outline-success"
          onClick={handleFindUsers}
          disabled={state.emailAddress.length === 0}
        >
          Find
        </Button>
      </div>
    </div>
  )
}

export default GetGatewayEmailUsers
